// extracted by mini-css-extract-plugin
export default {"record":"NewRecord_record__e1G++","numRecord":"NewRecord_numRecord__OOZJe","comma":"NewRecord_comma__X4NQc"};